import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    showAiOptimizeModal: false,
    showAiWriteModal: false,
    aiHostingCache: false,
    aiHostingInitObj: {},
    diagnosisDetail: undefined,
    edmEmailListMap: {},
    draftCurrentTab: 'commonTask',
    autoDevFrom: 'empty',
    hostingCurrentTab: 'mine',
    editInfoState: null,
    baseInfoState: null,
    contactInfoState: null,
    saveToHostingBoxCc: null,
};
const AiWriteMailSlice = createSlice({
    name: 'AiWriteMailReducer',
    initialState,
    reducers: {
        updateCache: (state, action) => {
            const { editInfo, baseInfo, contactInfo, saveToHostingBoxCc } = action.payload;
            if (editInfo)
                state.editInfoState = editInfo;
            if (baseInfo)
                state.baseInfoState = baseInfo;
            if (typeof saveToHostingBoxCc === 'boolean')
                state.saveToHostingBoxCc = saveToHostingBoxCc;
            if (contactInfo)
                state.contactInfoState = contactInfo;
        },
        clearCache: state => {
            state.editInfoState = null;
            state.baseInfoState = null;
            state.saveToHostingBoxCc = null;
            state.contactInfoState = null;
        },
        changeShowAiWriteModal: (state, action) => {
            const { show } = action.payload;
            state.showAiWriteModal = show;
        },
        changeShowAiOptimizeModal: (state, action) => {
            const { show } = action.payload;
            state.showAiOptimizeModal = show;
        },
        updateAiHostingCache: (state, action) => {
            const { cache } = action.payload;
            state.aiHostingCache = cache;
        },
        changeAiHostingInitObj: (state, action) => {
            const aiHostingInitObj = Object.assign({}, action.payload);
            state.aiHostingInitObj = aiHostingInitObj;
            if (!aiHostingInitObj.type) {
                state.editInfoState = null;
                state.baseInfoState = null;
                state.contactInfoState = null;
            }
        },
        changeEdmEmailListMap: (state, action) => {
            const edmEmailList = Object.assign({}, action.payload);
            state.edmEmailListMap[edmEmailList.key] = edmEmailList.val;
        },
        changeDiagnosisDetail: (state, action) => {
            state.diagnosisDetail = action.payload.diagnosisDetail;
        },
        updateDraftCurrentTab: (state, action) => {
            state.draftCurrentTab = action.payload.draftCurrentTab;
        },
        updateHostingCurrentTab: (state, action) => {
            state.hostingCurrentTab = action.payload.hostingCurrentTab;
        },
        updateAutoDevFrom: (state, action) => {
            state.autoDevFrom = action.payload;
        },
    },
});
export const { actions } = AiWriteMailSlice;
export default AiWriteMailSlice.reducer;
